/**
 * Normalises a column header to Title Case, so every list reads the same way
 * regardless of how its label was entered in Tolgee ("Sub area", "sub area"
 * and "Sub Area" all render alike).
 *
 * A word is left exactly as written when it already carries an uppercase
 * letter, a digit or a slash — that covers acronyms (ET, GPS, SDI-12, MK2) and
 * units ("(l/m)", "(mm/h)"), which Title Case would otherwise mangle into
 * "Sdi-12" and "(Mm/h)".
 *
 * A short parenthesised token is left alone as well, because it is a unit
 * rather than a word and units are case-sensitive: "(s)" is seconds, while
 * "(S)" is siemens. The length cap is what keeps this from swallowing an
 * ordinary parenthesised word — "(default)" still title-cases.
 */
const UNIT_MAX_LENGTH = 4

const isFixedToken = (word: string) => {
  if (/[A-Z0-9/]/.test(word)) return true
  const unit = word.match(/^\((.*)\)[.,;:]?$/)
  return unit != null && unit[1].length <= UNIT_MAX_LENGTH
}

export const toHeaderCase = (label: string): string =>
  label
    .split(' ')
    .map((word) => {
      if (!word || isFixedToken(word)) return word
      // Capitalise past any opening bracket or quote the word starts with.
      const index = word.search(/[\p{L}]/u)
      if (index < 0) return word
      return (
        word.slice(0, index) + word[index].toUpperCase() + word.slice(index + 1)
      )
    })
    .join(' ')

export default toHeaderCase
